import { FunctionComponent, ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { LinkProps, Stack, Typography, styled } from '@mui/material';
import { Roles } from '@/core/types';
import useAuth from '@/shared/context/auth-context';
import EmptyAdminPanelPage from '@/shared/components/EmptyAdminPanelPage';

const CustomersPageLink = styled(Link)<LinkProps>(({ theme }) => ({
	color: theme.palette.primary.dark,
}));

const LEVIANT_ADMIN_MESSAGE = (
	<>
		Please see the <CustomersPageLink to={'/customers'}>Customers section</CustomersPageLink>.
	</>
);
const OTHER_ROLES_MESSAGE = 'Please, contact your supervisor.';

const DashboardEmpty: FunctionComponent = (): ReactElement => {
	const { user } = useAuth();
	const message = user?.role === Roles.LEVIANT_ADMIN ? LEVIANT_ADMIN_MESSAGE : OTHER_ROLES_MESSAGE;

	return (
		<EmptyAdminPanelPage title="Dashboard Overview">
			<Stack justifyContent="center" alignItems="center" textAlign="center">
				<Typography component="h1" variant="h2">
					No sites available
				</Typography>
				<Typography component="h2" variant="h6">
					{message}
				</Typography>
			</Stack>
		</EmptyAdminPanelPage>
	);
};

export default DashboardEmpty;
